import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Button, Card, Input, Modal } from "antd";
import React, { useEffect, useState } from "react";
import "./index.scss";
import { useMutate } from "../../../hooks/useMutate";
import { RouteHttpVerb } from "@tatum/utils";
import { Spinner, Container } from "../../../components";
import { useStores } from "../../../store";
export var PasteApiKey = function PasteApiKey() {
  var gridStyle = {
    width: "100%",
    align: "center"
  };

  var _useMutate = useMutate({
    path: "/api-key",
    method: RouteHttpVerb.POST
  }),
      data = _useMutate.data,
      mutate = _useMutate.mutate,
      loading = _useMutate.loading;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      apiKey = _useState2[0],
      setApiKey = _useState2[1];

  var _useStores = useStores(),
      pageStore = _useStores.pageStore,
      apiKeyStore = _useStores.apiKeyStore;

  useEffect(function () {
    if (data === null || data === void 0 ? void 0 : data.version) {
      Modal.success({
        title: "API key successfully set up.",
        content: "Your API key was successfully set up and you are ready to mint NFTs!",
        okText: "Mint your first NFT!",
        onOk: function onOk() {
          apiKeyStore.setApiKey(data);
          window.location.reload();
        }
      });
    }
  }, [data]);
  return /*#__PURE__*/React.createElement(Container, {
    isGridCard: true
  }, /*#__PURE__*/React.createElement(Card, {
    title: "Step 2 - Paste your API key below (Final step)"
  }, /*#__PURE__*/React.createElement(Card.Grid, {
    hoverable: false,
    style: gridStyle
  }, /*#__PURE__*/React.createElement("div", {
    className: "paste-api-key"
  }, "Paste your API key"), /*#__PURE__*/React.createElement("div", {
    className: "input-container"
  }, /*#__PURE__*/React.createElement(Input, {
    onChange: function onChange(event) {
      return setApiKey(event.target.value);
    },
    size: "large",
    placeholder: "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
  }))), /*#__PURE__*/React.createElement(Card.Grid, {
    hoverable: false,
    style: gridStyle
  }, loading ? /*#__PURE__*/React.createElement(Spinner, null) : /*#__PURE__*/React.createElement(Button, {
    type: "primary",
    onClick: function onClick() {
      return mutate({
        apiKey: apiKey
      });
    }
  }, "Finish Setup"))));
};